import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

export default function MessagesLoading() {
  return (
    <div className="container mx-auto p-6 h-[calc(100vh-8rem)]">
      <div className="grid h-full gap-6 lg:grid-cols-3">
        {/* Conversations list skeleton */}
        <Card className="lg:col-span-1">
          <CardHeader>
            <Skeleton className="h-6 w-32" />
          </CardHeader>
          <CardContent className="p-0">
            <div className="space-y-1">
              {[...Array(8)].map((_, i) => (
                <div key={i} className="p-4 border-b last:border-b-0">
                  <div className="flex items-start gap-3">
                    <Skeleton className="h-12 w-12 rounded-full" />
                    <div className="flex-1 space-y-2">
                      <div className="flex justify-between">
                        <Skeleton className="h-4 w-24" />
                        <Skeleton className="h-3 w-12" />
                      </div>
                      <Skeleton className="h-3 w-full" />
                      <Skeleton className="h-3 w-2/3" />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>

        {/* Message area skeleton */}
        <Card className="lg:col-span-2">
          <CardHeader>
            <div className="flex items-center gap-3">
              <Skeleton className="h-10 w-10 rounded-full" />
              <div className="space-y-2">
                <Skeleton className="h-4 w-32" />
                <Skeleton className="h-3 w-24" />
              </div>
            </div>
          </CardHeader>
          <CardContent className="flex flex-col h-[calc(100%-5rem)]">
            {/* Messages skeleton */}
            <div className="flex-1 space-y-4 overflow-hidden">
              {[...Array(6)].map((_, i) => (
                <div key={i} className={`flex ${i % 2 === 0 ? 'justify-start' : 'justify-end'}`}>
                  <div className={`max-w-[70%] ${i % 2 === 0 ? 'items-start' : 'items-end'} space-y-2`}>
                    <div className={`rounded-lg p-3 ${i % 2 === 0 ? 'bg-muted' : 'bg-primary/10'}`}>
                      <Skeleton className={`h-4 ${i % 3 === 0 ? 'w-48' : i % 3 === 1 ? 'w-32' : 'w-64'}`} />
                    </div>
                    <Skeleton className="h-2 w-12" />
                  </div>
                </div>
              ))}
            </div>
            
            {/* Message input skeleton */}
            <div className="border-t pt-4 mt-4">
              <div className="flex gap-2">
                <Skeleton className="h-10 flex-1" />
                <Skeleton className="h-10 w-20" />
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}